import { CSSProperties } from 'react';

const styles: Record<string, CSSProperties> = {
    sparkle: {
        filter: 'drop-shadow(0px 2px 8px rgba(0, 0, 0, 0.2)) drop-shadow(0px 1px 2px rgba(0, 0, 0, 0.10))',
    },
};

export function Sparkle() {
    return (
        <svg
            style={styles.sparkle}
            xmlns="http://www.w3.org/2000/svg"
            width="2em"
            height="2em"
            viewBox="0 0 48 48"
            fill="none"
        >
            <path
                d="M13.411 4.96028C12.906 3.67991 11.094 3.67991 10.589 4.96028L9.23865 8.38415C9.08448 8.77505 8.77505 9.08448 8.38415 9.23865L4.96028 10.589C3.67991 11.094 3.67991 12.906 4.96028 13.411L8.38415 14.7613C8.77505 14.9155 9.08448 15.2249 9.23865 15.6158L10.589 19.0397C11.094 20.3201 12.906 20.3201 13.411 19.0397L14.7613 15.6158C14.9155 15.2249 15.2249 14.9155 15.6158 14.7613L19.0397 13.411C20.3201 12.906 20.3201 11.094 19.0397 10.589L15.6158 9.23865C15.2249 9.08448 14.9155 8.77505 14.7613 8.38415L13.411 4.96028Z"
                fill="white"
            />
            <path
                d="M32.4692 17.6805C31.5855 15.4398 28.4145 15.4398 27.5308 17.6805L25.1676 23.6723C24.8978 24.3563 24.3563 24.8978 23.6723 25.1676L17.6805 27.5308C15.4398 28.4145 15.4398 31.5855 17.6805 32.4692L23.6723 34.8324C24.3563 35.1022 24.8978 35.6437 25.1676 36.3277L27.5308 42.3195C28.4145 44.5602 31.5855 44.5602 32.4692 42.3195L34.8324 36.3277C35.1022 35.6437 35.6437 35.1022 36.3277 34.8324L42.3195 32.4692C44.5602 31.5855 44.5602 28.4145 42.3195 27.5308L36.3277 25.1676C35.6437 24.8978 35.1022 24.3563 34.8324 23.6723L32.4692 17.6805Z"
                fill="white"
            />
        </svg>
    );
}
